module.exports = __webpack_public_path__ + "img/search_w.8b4d090b.svg";